<template>
  <div class="d-flex flex-column pa-4">
    <div v-if="newsItem.image">
      <v-img :src="newsItem.image" />
    </div>
    <div class="d-flex justify-space-between pt-4 news-title">
      {{ newsItem.title }}
      <!-- <a class="text-decoration-none" style="width:30px;height:30px;" target="_blank" :href="newsItem.url">
            <v-btn style="width:30px;height:30px;" icon><v-icon size="24">link</v-icon></v-btn>
        </a> -->
    </div>
    <div class="d-flex pt-4 align-center">
      <div
        class="school-logo"
        :style="`border-color: ${getSchoolColour(newsItem.domain)}`"
      >
        <v-img
          class="flex-shrink-0 flex-grow-0"
          width="22"
          height="22"
          :src="logo"
        />
      </div>
      <span class="pl-2 byline" v-html="caption" />
    </div>

    <div
      v-if="newsItem.tags && newsItem.tags.length > 0"
      class="d-flex align-center mt-3"
    >
      <v-icon size="24" class="pr-2">
        mdi-text-box-multiple-outline
      </v-icon>
      <span class="tags">
        {{ newsItem.tags.join(", ") }}
      </span>
    </div>
    <div class="pt-5 description" v-html="description" />
  </div>
</template>
<script>
import { AppIcon } from "@nswdoe/doe-ui-core";
import linkifyHtml from "linkify-html";
const NewsInfo = {
  components: {
    AppIcon
  },
  name: "NewsInfo",
  computed: {
    logo() {
      let schoolId = this.newsItem.domain;
      if (schoolId != "global") {
        return this.schoolImages.filter(
          schoolInfo => schoolInfo.schoolId == schoolId
        )[0]?.logo;
      }
      return "/NSWGov_Logo-40.png";
    },
    schoolName() {
      let schoolId = this.newsItem.domain;
      if (schoolId != "global") {
        return this.schoolImages.filter(
          schoolInfo => schoolInfo.schoolId == schoolId
        )[0]?.name;
      }
      return "global";
    },
    description() {
      let options = {
        target: "_blank"
      };
      return linkifyHtml(this.newsItem.description, options);
    },
    caption() {
      return this.$t("news.caption", {
        date: this.newsItem.created,
        school:
          this.newsItem.domain === "global"
            ? this.$t("news.personalise.department")
            : this.schoolName
      });
    }
  },
  methods: {
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.schoolImages.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.colour;
      }
      return "#264189";
    }
  },
  props: {
    newsItem: {
      type: Object,
      default: function() {
        return {};
      }
    },
    schoolImages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};

export default NewsInfo;
</script>
<style lang="scss" scoped>
.news-title {
  font-weight: 500;
  font-size: 30px;
}
.byline {
  font-size: 14px;
  color: #4c4f55;
}
.description {
  font-size: 18px;
  color: #4c4f55;
  white-space: pre-line;
}
.tags {
  font-size: 14px;
  color: #4c4f55;
}
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
}
</style>
